import styled from 'styled-components'

const StyledInput = styled.input`
width: 100%;
min-width: 50px;
border-radius: 15px;
border: 1px solid lightgray;
padding: 10px 12px;
margin: 10px 0px;
text-align: center;
box-shadow: inset 0px 0px 3px lightgray;
color: gray;

:focus {
  outline: none;
}
`

export const Inputbox = props => {
  return <StyledInput {...props} />
}